import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { RadioButton } from 'primereact/radiobutton';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import { PendenciasWizard, setPendencia } from '../../ValidacaoWizard';
import { dominioDemandaCirurgica } from '../../../../config/database';
import 'assets/css/geral.css';

const TextMaskCelularCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

const TextMaskTelefoneCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

const TextMaskCPFCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

TextMaskCelularCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

TextMaskTelefoneCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

TextMaskCPFCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

class CriarPaciente extends Component {
  state = {
    informacoesPaciente: {},
    listaConvenio: [],
    convenio: null,
    peso: null,
    celular: null,
    telefone: null,
    email: null,
    criarNovoPaciente: false,
    novoPaciente: {},
  };

  componentDidMount() {
    const paciente = localStorage.getItem('paciente');
    const convenio = localStorage.getItem('convenio');
    const peso = localStorage.getItem('peso');
    const telefone = localStorage.getItem('telefone');
    const celular = localStorage.getItem('celular');
    const email = localStorage.getItem('email');
    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));
    const novoPaciente = localStorage.getItem('novoPaciente');

    if (paciente) {
      this.setState({
        informacoesPaciente: JSON.parse(paciente),
        criarNovoPaciente: false,
      });
    }

    if (convenio)
      if (JSON.parse(convenio).id !== configuracoes.convenioPadrao)
        this.setState({ convenio: JSON.parse(convenio) });
    if (peso) this.setState({ peso });

    if (telefone) this.setState({ telefone });
    else if (paciente)
      this.setState({
        telefone: JSON.parse(paciente).TELEFONE ? `14${JSON.parse(paciente).TELEFONE}` : '',
      });
    if (celular) {
      this.setState({ celular });
    } else if (paciente) {
      this.setState({
        celular: JSON.parse(paciente).CELULAR ? `14${JSON.parse(paciente).CELULAR}` : '',
      });
    }
    if (email) this.setState({ email });
    else if (paciente) this.setState({ email: JSON.parse(paciente).EMAIL });

    if (novoPaciente) {
      this.setState({
        novoPaciente: JSON.parse(novoPaciente),
        criarNovoPaciente: true,
      });
    }

    dominioDemandaCirurgica
      .get(`/api/convenioPorCategoria/${configuracoes.categoriaConvenioSuplementar}`)
      .then(response => {
        this.setState({ listaConvenio: response.data });
      });
  }

  getSexo = () => {
    if (this.state.informacoesPaciente.COD_SEXO) {
      return this.state.informacoesPaciente.COD_SEXO === 'M' ? 'Masculino' : 'Feminino';
    }

    return null;
  };

  getSexo = cod_sexo => {
    if (!cod_sexo) return null;

    return cod_sexo === 'M' ? 'Masculino' : 'Feminino';
  };

  getDataNascimentoFormatada = () => {
    if (this.state.informacoesPaciente.DAT_NASCIMENTO) {
      const data = new Date(this.state.informacoesPaciente.DAT_NASCIMENTO);
      data.setDate(data.getDate() + 1);
      return data.toLocaleDateString('pt-BR');
    }

    return null;
  };

  renderEscolherAcaoPesquisarOuCadastrarPaciente = () => {
    return (
      <>
        <div className="div-escolher-acao-pesquisar-cadastrar">
          <RadioButton
            inputId="pesquisarPaciente"
            disabled
            checked={this.state.criarNovoPaciente === false}
          />
          <label className="label-escuro" htmlFor="pesquisarPaciente">
            Pesquisar Paciente
          </label>
          <RadioButton
            inputId="criarPaciente"
            disabled
            checked={this.state.criarNovoPaciente === true}
          />
          <label className="label-escuro" htmlFor="criarPaciente">
            Cadastrar Novo Paciente
          </label>
        </div>
      </>
    );
  };

  formatDate = date => {
    if (date.getYear() < 1900) return null;

    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  };

  renderCorpoPesquisarPaciente = () => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Dados do paciente</h3>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="prontuario"
              variant="outlined"
              fullWidth
              id="prontuario"
              label="Prontuário"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.state.informacoesPaciente.NRO_PRONTUARIO}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <TextField
              autoComplete="off"
              name="nome"
              variant="outlined"
              fullWidth
              id="nome"
              label="Nome"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.state.informacoesPaciente.NOM_PESSOA}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              name="nascimento"
              variant="outlined"
              fullWidth
              id="nascimento"
              label="Nascimento"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.getDataNascimentoFormatada()}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              name="sexo"
              variant="outlined"
              fullWidth
              id="sexo"
              label="Sexo"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.getSexo(this.state.informacoesPaciente.COD_SEXO)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="telefone"
              label="Telefone"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={this.state.telefone}
              InputProps={{
                inputComponent: TextMaskTelefoneCustom,
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="celular"
              label="Celular"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={this.state.celular}
              InputProps={{
                inputComponent: TextMaskCelularCustom,
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              id="email"
              label="E-mail"
              InputLabelProps={{ shrink: true }}
              value={this.state.email}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="peso"
              type="number"
              variant="outlined"
              fullWidth
              id="peso"
              label="Peso"
              value={this.state.peso}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Autocomplete
              id="convenio"
              options={this.state.listaConvenio}
              getOptionLabel={option => `${option.descricao}`}
              fullWidth
              value={this.state.convenio}
              onChange={(e, values) => {
                localStorage.setItem('convenio', JSON.stringify(values));
                this.setState({ convenio: values });
                setPendencia(0, PendenciasWizard.convenio, 'pendenciasPacienteSuplementar');
              }}
              renderInput={params => <TextField {...params} label="Convênio" variant="outlined" />}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  renderCorpoCadastrarPaciente = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <h3>Dados do paciente</h3>
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            name="nome"
            variant="outlined"
            fullWidth
            id="nome"
            label="Nome"
            required
            value={this.state.novoPaciente?.nome ?? null}
            InputProps={{
              style: { textTransform: 'uppercase' },
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            autoComplete="off"
            type="date"
            name="dataNascimento"
            variant="outlined"
            fullWidth
            id="dataNascimento"
            label="Data de Nascimento"
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.dataNascimento ?? null}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="sexo"
            fullWidth
            variant="outlined"
            required
            value={this.getSexo(this.state.novoPaciente?.sexo) ?? null}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            name="nomeMae"
            variant="outlined"
            fullWidth
            id="nomeMae"
            label="Mãe"
            required
            value={this.state.novoPaciente?.nomeMae ?? null}
            InputProps={{
              readOnly: true,
              style: { textTransform: 'uppercase' },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="cpf"
            name="cpf"
            label="CPF"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.cpf ?? null}
            required
            InputProps={{
              inputComponent: TextMaskCPFCustom,
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="cns"
            name="cns"
            label="CNS"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.cns ?? null}
            InputProps={{
              maxLength: '15',
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="telefone"
            name="telefone"
            label="Telefone"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.telefone ?? null}
            InputProps={{
              inputComponent: TextMaskTelefoneCustom,
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="celular"
            name="celular"
            label="Celular"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.celular ?? null}
            InputProps={{
              inputComponent: TextMaskCelularCustom,
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            name="email"
            type="email"
            variant="outlined"
            fullWidth
            id="email"
            label="E-mail"
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.email ?? null}
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            autoComplete="off"
            name="peso"
            type="number"
            variant="outlined"
            fullWidth
            id="peso"
            label="Peso"
            value={this.state.peso ?? null}
            maxLength="4"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={9}>
          <Autocomplete
            id="convenio"
            options={this.state.listaConvenio}
            getOptionLabel={option => `${option.descricao}`}
            fullWidth
            value={this.state.convenio}
            onChange={(e, values) => {
              localStorage.setItem('convenio', JSON.stringify(values));
              this.setState({ convenio: values });
              setPendencia(0, PendenciasWizard.novoPacienteConvenio);
            }}
            renderInput={params => <TextField {...params} label="Convênio" variant="outlined" />}
          />
        </Grid>
      </Grid>
    );
  };

  render() {
    return (
      <Container>
        {this.renderEscolherAcaoPesquisarOuCadastrarPaciente()}
        {!this.state.criarNovoPaciente
          ? this.renderCorpoPesquisarPaciente()
          : this.renderCorpoCadastrarPaciente()}
      </Container>
    );
  }
}

export default CriarPaciente;
